// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() { scrollFunction() };

function scrollFunction() {
  const toTopButton = document.getElementById("to-top-desktop");
  const navbarCTA   = document.querySelector(".navbar-cta");

  if (document.body.scrollTop > 70 || document.documentElement.scrollTop > 70) {
    toTopButton.style.display = "block";

    if (navbarCTA) { navbarCTA.classList.remove("hide"); }

  } else {
    toTopButton.style.display = "none";

    if (navbarCTA) { navbarCTA.classList.add("hide"); }

  }
}

const navbar = document.querySelector('.navbar')

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  if (navbar) {
    navbar.scrollIntoView({behavior: 'smooth'})
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', })
  }
}

const topButton = document.getElementById("to-top-desktop");

topButton.addEventListener("click", function(e) {
  topFunction();
})
